module.exports = __webpack_public_path__ + "static/img/en_US.2a3a7e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/langs/en_US.png
// module id = Ug33
// module chunks = 0 1 2